export default __webpack_public_path__ + "static/events-dark-4475cad08b67d518927a01ea1bb21218.png";